import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { usePagination } from '../pagination/usePagination';
import { getListAgreements } from '../../services/seller/seller'



export const useSeller = () => {

    const history = useHistory();

    const [sellerD, setSellerD] = useState([]);
    const [sellerID, setSellerID] = useState([]);

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const [loadingExport, setLoadingExport] = useState(false);
    const [searchSeller, setSearchSeller] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [doctorCount, setDoctorCount] = useState(0);
    // console.log("😺 doctorCount", doctorCount);
    const [errorTransfer, setErrorTransfer] = useState({
        origin: "",
        destiny: ""
    });

    useEffect(() => {

        getSeller();
        getSellerAll();


    }, [history.location]);



    const toggle = () => {
        setModal(prev => !prev);
    }

    const closeModalSeller = () => {
        setModal(false);
    };

    const [formValues, handleInputChange, reset, handleUpdateValues, handlePickerValues] = useForm({
        name: "",
        paternal_surname: "",
        maternal_surname: "",
        number_phone: "",
        email: "",
        id_seller_origin: 0,
        id_seller_destiny: 0
    });


    const {
        name, paternal_surname, maternal_surname, number_phone, email,
        id_seller_origin,
        id_seller_destiny
    } = formValues;


    const [validaciones, SetValidaciones] = useState({
        name_valid: false,
        paternal_surname_valid: false,
        maternal_surname_valid: false,
        number_phone_valid: false,

    });


    const handleCreate = () => {

        handleUpdateValues({
            name: "",
            paternal_surname: "",
            maternal_surname: "",
            number_phone: "",
            email: ""

        });

        SetValidaciones({
            name_valid: false,
            paternal_surname_valid: false,
            maternal_surname_valid: false,
        })

        setSellerID(0);
        setMethod("create");
        setModalTitle("Registrar un Vendedor");
        toggle();
    }


    const getSeller = async () => {

        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "Seller/List");

        if (respuesta.code === 200) {

            if (respuesta.data.length >= 1) {

                let ListSeller = [];
                let startItems = 0;
                let endItems = numberItems;
                let aux = numberItems * currentPage;

                endItems = aux;
                startItems = endItems - numberItems;


                respuesta.data.forEach((value, index) => {

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    ListSeller.push({
                        id_seller: value.id_seller,
                        name: value.name,
                        paternal_surname: value.paternal_surname,
                        maternal_surname: value.maternal_surname,
                        number_phone: value.number_phone,
                        email: value.email,
                        visibleTable: visibleTable
                    });
                });
                setSellerD(ListSeller);
                setDataSeller(ListSeller)
            }
            else {
                createSweet("error", "warning", "Hubo un error!", "No se encontraron vendedores");
                setSellerD([]);
            }
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getSeller);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Vendedores", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Vendedores", respuesta.data.msg);
        }
    }


    const numberItems = 10;

    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(sellerD.length, numberItems);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;

        let listSellerr = [];
        sellerD.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listSellerr.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setSellerD(listSellerr);

    }, [totalPageCount, currentPage]);



    const [dataSeller, setDataSeller] = useState([]);


    const handleSearchSeller = (value) => {
        setSearchSeller(value);

        let busqueda = value.toUpperCase();
        let newMethod = [];

        dataSeller.forEach(element => {
            const cadena = (element.name || "").toUpperCase();

            if (cadena.includes(busqueda)) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });

        setSellerD(newMethod);
    };


    const handleClearSeller = () => {
        setSearchSeller("");
        localStorage.removeItem("globalFilter");
        setSellerD(dataSeller);
    };


    const saveCreate = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }



        let mData = formValues;

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(mData)
        };

        const respuesta = await sendRequest(requestOptions, "Seller/Create");
        if (respuesta.code === 200) {

            getSeller();
            getSellerAll();
            reset();
            createSweet("create", "success", "Exito!", "Vendedor ");
            setLoading(false);
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveCreate);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Vendedor", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Vendedor", respuesta.data.msg);

        }
    }

    const handleUpdate = (id_seller) => {

        let sellerR = sellerD.find(b => b.id_seller === parseInt(id_seller));

        handleUpdateValues({
            name: sellerR.name,
            paternal_surname: sellerR.paternal_surname,
            maternal_surname: sellerR.maternal_surname,
            number_phone: sellerR.number_phone,
            email: sellerR.email
        });


        setSellerID(id_seller);
        setMethod("update");
        setModalTitle("Modificar Vendedor");
        toggle();
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }


        let body = {
            id_seller: sellerID,
            ...{ ...formValues }
        };

        let requestOptions = {
            method: 'PUT',
            body: JSON.stringify(body)
        };

        const respuesta = await sendRequest(requestOptions, "Seller");

        if (respuesta.code === 200) {
            getSeller();
            getSellerAll();
            createSweet("create", "info", "Exito!", "Vendedor Actualizado");
            setLoading(false);
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Vendedor", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Vendedor", respuesta.data.msg);
        }
    }


    // ? CONFIGUARTION SELLER

    const [arraySeller, setArraySeller] = useState([])
    const [loadingSeller, setLoadingSeller] = useState(false)

    const handleDelete = (id_seller) => {

        let sellerR = sellerD.find(b => b.id_seller === parseInt(id_seller));

        verifyTheSeller(id_seller)


        handleUpdateValues({
            name: sellerR.name
        });

        setSellerID(id_seller);
        setMethod("delete");
        setModalTitle("Eliminar Vendedor");
        toggle();


    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };
        const respuesta = await sendRequest(requestOptions, `Seller/${sellerID}`);

        if (respuesta.code === 200) {
            getSeller();
            getSellerAll();
            setLoading(false);
            createSweet("create", "info", "Exito!", "Vendedor eliminado");
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Vendedor", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Vendedor", respuesta.data.msg);
            setLoading(false);
        }
    }


    const validarForm = () => {

        let statusValidacion = false;
        let newValidaciones = {};




        if (formValues.name.length < 3) {
            newValidaciones = {
                ...newValidaciones,
                name_valid: true
            }
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                name_valid: false
            };
        }

        if (formValues.paternal_surname.length < 3) {
            newValidaciones = {
                ...newValidaciones,
                paternal_surname_valid: true
            }
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                paternal_surname_valid: false
            };
        }

        if (formValues.maternal_surname.length < 3) {
            newValidaciones = {
                ...newValidaciones,
                maternal_surname_valid: true
            }
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                maternal_surname_valid: false
            };
        }




        SetValidaciones(newValidaciones);
        return statusValidacion;

    }

    // #region Excel

    const handleExportExcelSeller = async () => {
        setLoadingExport(true);

        const XLSX = await import("xlsx");

        const _report = sellerD.map(seller => ({
            Nombre: seller.name ?? "---",
            Apellido_Paterno: seller.paternal_surname ?? "---",
            Apellido_Materno: seller.maternal_surname ?? "---",
            Teléfono: seller.number_phone ?? "---",
            Correo: seller.email ?? "---",

        }));

        const worksheet = XLSX.utils.json_to_sheet(_report);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Listado");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const dataBlob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Listado_Laboratorio_externo.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);



        setLoadingExport(false);
    };

    //#endregion

    const [modalTransfer, setModalTransfer] = useState(false);

    const openDialogTransfer = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModalTransfer(true);
    };


    const closeTransfer = () => {
        setModalTransfer(false);
        setShowConfirm(false);

        handleUpdateValues({
            id_seller_origin: 0,
            id_seller_destiny: 0
        });
    };
    const handleCreateTransfer = () => {
        setMethod("create");
        setModalTitle("Transferir cartera de clientes");
        openDialogTransfer("Transferir cartera de clientes", "create");
    }

    const [listSellers, setListSellers] = useState([]);

    const getSellers = async () => {
        const response = await sendRequest("GET", "Seller/List", "Vendedores");

        if (response && response.data && response.data.length > 0) {
            const _list_seller = response.data.map(_seller => ({
                value: _seller.id_seller,
                label: _seller.name + " " + _seller.paternal_surname + " " + _seller.maternal_surname,

            }));

            setListSellers(_list_seller);
        } else {
            setListSellers([]);
        }

    };
    useEffect(() => {
        getSellers();
    }, []);

    //#region TRANSFER SELLER 
    const handleTransfer = async (confirmed = false) => {

        if (!id_seller_origin || !id_seller_destiny) {
            createSweet("error", "warning", "Transferencia", "Debes seleccionar ambos vendedores");
            return;
        }

        const isValid = runValidation();
        if (!isValid) return;

        if (!confirmed) {
            setShowConfirm(true);
            return;
        }

        let body = {
            oldSellerId: id_seller_origin,
            newSellerId: id_seller_destiny
        };

        let requestOptions = {
            method: 'PUT',
            body: JSON.stringify(body)
        };

        const response = await sendRequest(requestOptions, "Seller/UpdateDoctorsSeller");

        if (response.code === 200) {
            createSweet("create", "success", "Éxito", "Transferencia realizada correctamente");
            closeTransfer();
            // getSeller();
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleTransfer);
        }
        else {
            createSweet("error", "error", "Transferencia", "Error al transferir");
        }
    };

    //#endregion


    const getDoctorsCount = async (id) => {
        if (!id) {
            setDoctorCount(0);
            return;
        }

        let requestOptions = {
            method: 'GET'
        };

        const response = await sendRequest(
            requestOptions,
            `Seller/GetDoctorsCount?id_seller=${id}`
        );


        if (response.code === 200) {
            setDoctorCount(response.data);
        }
    };

    useEffect(() => {
        if (id_seller_origin) {
            setDoctorCount(0);
            getDoctorsCount(id_seller_origin);
        } else {
            setDoctorCount(0);
        }
    }, [id_seller_origin]);


    const validateTransfer = () => ({
        origin: !id_seller_origin && "Selecciona vendedor origen",
        destiny: !id_seller_destiny && "Selecciona vendedor destino",
        same:
            id_seller_origin &&
            id_seller_destiny &&
            id_seller_origin === id_seller_destiny &&
            "Los vendedores no pueden ser iguales"
    });


    const runValidation = () => {
        const validation = validateTransfer();

        const newErrors = {
            origin: validation.origin || validation.same || "",
            destiny: validation.destiny || validation.same || ""
        };

        setErrorTransfer(newErrors);

        return !newErrors.origin && !newErrors.destiny;
    };

    const handleShowConfirm = () => {
        const isValid = runValidation();

        if (isValid) {
            setShowConfirm(true);
        }
    };

    //#region SELLER ALL
    const [listSellerAll, setListSellerAll] = useState([]);

    const getSellerAll = async () => {
        const response = await sendRequest("GET", "Seller/ListSellerAll", "Vendedores");

        if (response && response.data && response.data.length > 0) {
            const _list_seller = response.data.map(_seller => ({
                value: _seller.id_seller,
                label: _seller.name + " " + _seller.paternal_surname + " " + _seller.maternal_surname,
                deleted: _seller.deleted
            }));

            setListSellerAll(_list_seller);
        } else {
            setListSellerAll([]);
        }

    };

    useEffect(() => {
        getSellerAll();
    }, []);



    // endregion



    const verifyTheSeller = async (_id_seller) => {

        const response = await getListAgreements(_id_seller);
        if (response?.code === 200) {
            setLoadingSeller(true)
            setArraySeller(response?.data)

        }
    }





















    return {
        name, paternal_surname, maternal_surname, number_phone, email, sellerD, handleInputChange, handleCreate,
        method, modalTitle, loading, toggle, modal,
        totalPageCount, currentPage, nextPage, previousPage, goToPage, handleSearchSeller,
        saveCreate, handleUpdate, saveUpdate, handleDelete, saveDelete, validaciones, handleExportExcelSeller, loadingExport, closeModalSeller,
        handleClearSeller, searchSeller, modalTransfer, closeTransfer, handleCreateTransfer, listSellers,
        id_seller_origin, id_seller_destiny, handleTransfer, showConfirm, setShowConfirm, getDoctorsCount, doctorCount,
        setErrorTransfer, errorTransfer, handleShowConfirm, getSellerAll, listSellerAll,

        // *
        arraySeller, loadingSeller

    }
}
